import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, getToken, login as apiLogin, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      const token = getToken();
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const userData = await fetchMe();
        setUser(userData);
      } catch (err) {
        // authFailed (401/autre) → token déjà purgé dans fetchMe/authFetch
        // Erreur réseau → on garde le token pour un prochain chargement
        setUser(null);
        if (process.env.NODE_ENV === "development" && err?.authFailed) {
          console.warn("[auth] Session admin invalide — reconnectez-vous via /admin/login");
        }
      } finally {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    setUser(null);
    apiLogout();
  };

  const isAdmin = !!user && ["admin", "super_admin"].includes(user.role);

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated: !!user,
        isAdmin,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
